import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["value", "options", "open", "placeholder", "autoFocus", "size", "width", "minWidth", "maxWidth", "name", "onChange", "allOption", "disabled", "title", "renderValue", "dataTestId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { useForkRef } from '@cian/react-utils';
import { InputWrapper } from '../../../../internal/components/InputWrapper';
import { HiddenInput } from '../../../../internal/components/HiddenInput';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';
import { InputAdornment } from '../../../../inputAdornment';
import styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SelectInput = /*#__PURE__*/React.forwardRef(function SelectInput(props, ref) {
  const {
      value,
      options,
      open,
      placeholder,
      autoFocus,
      size,
      width,
      minWidth,
      maxWidth,
      name,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onChange,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      allOption,
      disabled,
      title,
      renderValue,
      dataTestId
    } = props,
    divProps = _objectWithoutProperties(props, _excluded);
  const [displayNode, setDisplayNode] = React.useState(null);
  const inputRef = useForkRef(setDisplayNode, ref);
  const label = React.useMemo(() => {
    if (!hasValue(value)) {
      return null;
    }
    const valueArray = Array.isArray(value) ? value : [value];
    const resultArray = options.reduce((result, option) => {
      if (valueArray.includes(option.value)) {
        result.push(option.label || option.value);
      }
      return result;
    }, []);
    if (renderValue) {
      return resultArray;
    }
    return resultArray.join(', ');
  }, [options, value, renderValue]);
  React.useEffect(() => {
    if (displayNode && autoFocus && !disabled) {
      displayNode.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayNode, autoFocus]);
  const renderContent = React.useMemo(() => {
    if (renderValue && label) {
      return Array.isArray(label) && label.map(renderValue);
    }
    return /*#__PURE__*/_jsxs("div", {
      className: styles['label-wrapper'],
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['label'],
        children: label
      }), Array.isArray(value) && !!value.length && /*#__PURE__*/_jsx("span", {
        className: styles['count'],
        children: value.length
      })]
    });
  }, [value, label, renderValue]);
  return /*#__PURE__*/_jsxs(InputWrapper, _objectSpread(_objectSpread({}, divProps), {}, {
    ref: inputRef,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    cursor: "pointer",
    tabIndex: divProps.tabIndex || 0,
    disabled: disabled,
    className: clsx(renderValue && styles["flexible_hight"], size && styles["flexible_hight_".concat(size)]),
    "data-testid": dataTestId,
    rightAdornment: /*#__PURE__*/_jsx(InputAdornment, {
      children: /*#__PURE__*/_jsx("div", {
        className: clsx(styles['arrow'], disabled && styles['disabled']),
        children: open ? /*#__PURE__*/_jsx(IconActionChevronUpSmall16, {
          color: disabled ? 'icon-main-disabled' : 'icon-main-default'
        }) : /*#__PURE__*/_jsx(IconActionChevronDownSmall16, {
          color: disabled ? 'icon-main-disabled' : 'icon-main-default'
        })
      })
    }),
    children: [/*#__PURE__*/_jsx(HiddenInput, {
      defaultValue: valueToHtml(value),
      name: name,
      disabled: disabled,
      tabIndex: -1
    }), label ? renderContent : /*#__PURE__*/_jsx("div", {
      className: styles['placeholder'],
      children: placeholder || title
    })]
  }));
});
function hasValue(value) {
  if (Array.isArray(value)) {
    return !!value.length;
  }
  return value !== null && value !== undefined;
}
function valueToHtml(value) {
  if (Array.isArray(value)) {
    return value.join(',');
  }
  if (value !== null && value !== undefined) {
    return String(value);
  }
  return;
}